

































































import { Prop, Vue, Component } from "vue-property-decorator";
import VIcon from "@/components/VIcon.vue";
import Notification, {
  NotificationFormat,
  NotificationTypes,
} from "@/models/Notifications";

export const DATE_FORMAT = "YYYY-MM-DD";

@Component({
  components: {
    VIcon,
  },
})
export default class NotificationItem extends Vue {
  @Prop({
    required: true,
  })
  readonly notification!: Notification;
  @Prop({ required: true }) readonly format!: NotificationFormat;

  get notificationTitle(): string {
    return NotificationTypes[this.notification.type]?.name;
  }

  get notificationIcon(): string {
    return NotificationTypes[this.notification.type]?.icon;
  }

  get dailyNotificationTime(): string {
    return this.$moment(this.notification.updatedAt).fromNow();
  }

  get periodStart(): string {
    return this.$moment(this.notification.startsAt).format(DATE_FORMAT);
  }

  get periodEnd(): string {
    return this.$moment(this.notification.endsAt).format(DATE_FORMAT);
  }

  get previousDayNotificationTime(): string {
    return this.$moment(this.notification.updatedAt).format("D MMM h:mm");
  }

  get notReadClass(): string {
    return this.notification?.status !== "read"
      ? "notification-item__to-read"
      : "";
  }

  get smallItem(): boolean {
    return this.format === "sm";
  }

  get parsedCreationDate(): string {
    return this.$moment(this.notification.createdAt).format(
      "YYYY-MM-DD HH:mm:ss"
    );
  }

  get parsedDurationType(): string {
    return this.notification.durationType;
  }

  get parsedTargetType(): string {
    return this.notification.target;
  }

  get isDailyNotification(): boolean {
    return this.$moment(this.notification.updatedAt).isSame(
      this.$moment(),
      "day"
    );
  }
  get isDataComplete(): boolean {
    return !!(
      this.notificationIcon &&
      this.notificationTitle &&
      this.dailyNotificationTime &&
      this.previousDayNotificationTime &&
      this.parsedCreationDate &&
      this.periodStart &&
      this.periodEnd &&
      this.parsedDurationType &&
      this.parsedTargetType
    );
  }

  downloadReport() {
    if (this.notification.url) {
      window.open(this.notification.url);
    }
  }
}
